import { round2, toNumber } from './money';

function addonsTotal(addons) {
  if (!Array.isArray(addons) || !addons.length) return 0;
  return addons.reduce((sum, a) => sum + toNumber(a?.price, 0), 0);
}

export function lineUnitPrice(line) {
  const base = toNumber(line?.basePrice, 0);
  const variantAdj = toNumber(line?.variant?.priceDelta, 0);
  const addons = addonsTotal(line?.addons);
  return round2(base + variantAdj + addons);
}

export function lineTotal(line) {
  const unit = lineUnitPrice(line);
  const qty = Math.max(1, toNumber(line?.qty, 1));
  return round2(unit * qty);
}

export function cartSubtotal(lines) {
  if (!Array.isArray(lines) || !lines.length) return 0;
  return round2(lines.reduce((sum, l) => sum + lineTotal(l), 0));
}

export function computeTax(subtotal, taxRatePct) {
  const rate = Math.max(0, toNumber(taxRatePct, 0)) / 100;
  return round2(subtotal * rate);
}

export function computeDiscount(subtotal, discount) {
  // discount: { type: 'flat'|'percent', value: number }
  if (!discount) return 0;
  const type = String(discount.type || '').toLowerCase();
  const value = Math.max(0, toNumber(discount.value, 0));
  if (type === 'percent') return round2((value / 100) * subtotal);
  if (type === 'flat') return round2(value);
  return 0;
}

